import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  Facebook,
  LinkedIn,
  Location,
  Mail,
  Phone,
  Twitter,
} from "../assets/icons";
import { Logo } from "../assets/Logo";
import { ColCenter, LinkText, Typography } from "../styles/StyledComponent";

export const Footer = () => {
  const navigateTo = useNavigate();
  const navigation = (path) => {
    navigateTo(`${path}`);
    window.scrollTo(0, 0);
  };

  return (
    <div style={{ background: "#097A57" }} className="mt-5 position-relative">
      <Container className="py-4">
        <img
          className="displayNone"
          src={require("../assets/wave.png")}
          alt=""
          width="100%"
          height="80%"
          style={{
            position: "absolute",
            zIndex: "0",
            left: "0px",
            bottom: "0px",
          }}
        ></img>
        <Row className="g-4" style={{ zIndex: "3", position: "relative" }}>
          <Col sm lg={4}>
            <Logo color="#fff"></Logo>
            <Typography color="#fff" className="mt-4">
              {
                "The most effective academic ERP solution for schools and colleges. Providing a single system to manage admissions online learning, and other academic processes."
              }
            </Typography>
          </Col>
          <ColCenter sm minwidth="188px" className="justify-content-start">
            <div className="m-sm-none me-auto">
              <Typography
                color="#fff"
                fontWeight="700"
                fontSize="20px"
                className="mb-2"
              >
                Quick Links
              </Typography>
              <LinkText className="py-1" onClick={() => navigation("/about")}>
                About
              </LinkText>
              <LinkText className="py-1" onClick={() => navigation("/modules")}>
                Modules
              </LinkText>
              <LinkText className="py-1" onClick={() => navigation("/partner")}>
                Partner
              </LinkText>
              <LinkText
                className="py-1"
                onClick={() => navigation("/our-client")}
              >
                Client
              </LinkText>
            </div>
          </ColCenter>
          <ColCenter sm minwidth="187px" className="justify-content-start">
            <div className="m-sm-none me-auto">
              <Typography
                color="#fff"
                fontWeight="700"
                fontSize="20px"
                className="mb-2"
              >
                Help
              </Typography>

              <LinkText
                className="py-1"
                onClick={() => navigation("/contact-us")}
              >
                Contact Us
              </LinkText>
              <LinkText
                className="py-1"
                onClick={() => navigation("/request-a-demo")}
              >
                Request A Demo
              </LinkText>
            </div>
          </ColCenter>

          <ColCenter sm className="justify-content-start" minwidth="265px">
            <div className="m-sm-none me-auto">
              <Typography
                color="#fff"
                fontWeight="700"
                fontSize="20px"
                className="mb-2"
              >
                Information
              </Typography>

              <LinkText className="py-1">
                <Phone /> +91 85810 04142
              </LinkText>
              <LinkText className="py-1" textTransform="none">
                <Mail />
                info@dynamic.net.np
              </LinkText>
              <LinkText className="py-1">
                <Location />
                {"Maharaja Enclave, Kaliket Nagar, Patna, Bihar, India"}
              </LinkText>
            </div>
          </ColCenter>
        </Row>
      </Container>
      <div
        style={{ background: "#005138", zIndex: "3", position: "relative" }}
        className="d-flex  justify-content-center align-items-center flex-wrap py-2 px-4"
      >
        <Typography color="#fff" fontWeight="400" fontSize="12px">
          {"Copyright © 2026 mydynamicerp.com All rights reserved."}
        </Typography>
        <div className="d-flex ms-4 footerMediaLinks">
          <Facebook />
          <LinkedIn />
          <Twitter />
        </div>
      </div>
    </div>
  );
};
